module.exports = __webpack_public_path__ + "img/52-image-1@2x.e2592e20.png";